import i18n from '@/i18n'; // Updated by script

export default function isRtl() {
  return i18n && i18n.dir() === 'rtl' ? true : false;
}
